<template>
  <div class="el-collapse" role="tablist" aria-multiselectable="true">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ElCollapse',
  componentName: 'ElCollapse',
  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default() {
        return [];
      },
    },
    defaultActive: {
      type: Boolean,
      default: true,
    },
    iconInactive: {
      type: String,
      default: 'expand_more',
    },
    iconActive: {
      type: String,
      default: 'expand_less',
    },
    iconPosition: {
      type: String,
      default: 'right',
    },
    alignIcon: {
      type: String,
      default: 'center',
    },
    headerClasses: {
      type: String,
      default: '',
    },
    iconClasses: {
      type: String,
      default: '',
    },
    contentClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeNames: [].concat(this.value),
      allNames: [],
    };
  },
  provide() {
    return {
      collapse: this,
    };
  },
  watch: {
    value(value) {
      this.activeNames = [].concat(value);
    },
  },

  created() {
    this.$on('item-click', this.handleItemClick);
  },
  methods: {
    setActiveNames(activeNames) {
      activeNames = [].concat(activeNames);
      let value = this.accordion ? activeNames[0] : activeNames;
      this.activeNames = activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    },

    setAllActive() {
      this.setActiveNames(this.allNames);
    },

    handleItemClick(item) {
      if (this.accordion) {
        this.setActiveNames(
          (this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name
        );
      } else {
        let activeNames = this.activeNames.slice(0);
        let index = activeNames.indexOf(item.name);
        if (index > -1) {
          activeNames.splice(index, 1);
        } else {
          activeNames.push(item.name);
        }
        this.setActiveNames(activeNames);
      }
    },
  },
};
</script>
